import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _10mpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"10mp"}/>
}
